import { cx } from "../../lib/cx.js";
/* empty css         */
import { jsx } from "react/jsx-runtime";
//#region src/components/List/List.tsx
/**
* A bulleted (or numbered) list of short points, `--list-gap` apart and indented by
* `--list-indent`, with no outer margin: "How files are read" in an Alert.
*/
function List({ ordered = false, className, ...rest }) {
	return /* @__PURE__ */ jsx(ordered ? "ol" : "ul", {
		...rest,
		className: cx("ds-list", className)
	});
}
//#endregion
export { List };

//# sourceMappingURL=List.js.map